import React from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";
import { FAQSections } from './FaqSections';
import { hostRulesQuestions } from './data/hostRulesInfo';

const HostRules = ({ hostRules = {}, intl }) => {
  return (
    <div className="ProductionFAQ">
      <FAQSections
        icon="rules"
        label={intl.formatMessage(get(hostRulesQuestions, 'rules.label'))}
        faqFn={get(hostRulesQuestions, 'rules.faq')}
        faqData={{
          ...hostRules
        }}
        intl={intl}
      />
    </div>
  );
};

HostRules.propTypes = {
  faqData: PropTypes.object,
  hostRules: PropTypes.object,
  expanded: PropTypes.bool,
  intl: PropTypes.object
};

export default HostRules;
